import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-321271e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center justify-between mb-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-400" }
const _hoisted_3 = { key: 0 }

import { onMounted, onUnmounted, ref, watch } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPage',
  props: {
		name: {
			type: String,
			default: "modal",
		},
		styleContent: {
			type: String,
			default: "flex",
		},
		styleFooter: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: "Modal Title",
		},
		styleModal: {
			type: String,
			default: "",
		},
		defaultStyle: {
			type: Boolean,
			default: true,
		},
	},
  emits: ["close", "mounted"],
  setup(__props, { emit: __emit }) {

	const emit = __emit;

	const typeAnimate = ref("animate__zoomIn");
	const props = __props;

	/**
	 * Varialbles
	 */

	// Stream surface View
	let modalView: any;

	function setModalView() {
		if (!modalView) {
			modalView = document.querySelector("#modalpage");
			// console.log("modalView open: ", modalView);
			document.body.appendChild(modalView);
		}
	}

	function closeModalView() {
		typeAnimate.value = "animate__zoomOutLeft";

		if (modalView) {
			// document.body.removeChild(modalView);
			modalView.style.display = "none";
			modalView.style.animation = "zoomOut";
			modalView = null;
		}
		emit("close", props.name);
	}

	onMounted(() => {
		setModalView();
		emit("mounted", props.name);
	});

	onUnmounted(() => {
		closeModalView();
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    onKeydown: _withKeys(closeModalView, ["esc"]),
    id: "modalpage",
    class: "fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center transition-all duration-100 ease-linear app-modal"
  }, [
    _createElementVNode("div", {
      id: "animate",
      class: _normalizeClass([
				__props.styleModal,
				typeAnimate.value,
				{
					'p-8 space-y-4 w-2/4 rounded-md bg-primary transition-all duration-100 ease-linear animate__animated  animate__faster_xx': __props.defaultStyle,
				},
			])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1),
        _createVNode(_component_Icon, {
          src: "/media/icons/close-icon.svg",
          css: "w-5 h-5 cursor-pointer p-3 hover:bg-gray-500 rounded",
          onClick: closeModalView
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([__props.styleContent])
      }, [
        (__props.title == 'Modal Title')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Set the content for Modal using slot name : content !"))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([__props.styleFooter, { flex: true }])
      }, [
        _renderSlot(_ctx.$slots, "footer")
      ], 2)
    ], 2)
  ], 32))
}
}

})